import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import { isNotRunningLocally, ENV } from '@stilingue/st-environment-controller-utils';

const shouldInstallSentry = isNotRunningLocally();

// This makes sure sentry will install only once
let isSentryInstalled = false;

(function() {
  if (shouldInstallSentry && !isSentryInstalled) {
    isSentryInstalled = true;
    Sentry.init({
      dsn: 'https://90e5e50e35bf4498be5ffb8a1a646603@o72524.ingest.sentry.io/5424662',
      integrations: [
        new Integrations.Vue({
          Vue,
          attachProps: true
        })
      ],
      release: process.env.VUE_APP_SENTRY_RELEASE,
      environment: ENV()
    });
  }
}());

export function insertSentryMetadata({
  username,
  email,
  id,
} = {}) {
  // Should have Sentry installed and all user attributes
  if ([isSentryInstalled, username, email, id].every(Boolean)) {
    return Sentry.setUser({
      username,
      email,
      id,
    });
  }
  if (shouldInstallSentry) {
    // If should install and do not have mandatory info
    console.error('It may be missing some mandatory info, check the following', isSentryInstalled, username, email, id);
  }
}

